import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

const LEVELS = [
  { key: "region", label: "Région" },
  { key: "prefecture", label: "Préfecture" },
  { key: "commune", label: "Commune" },
  { key: "canton", label: "Canton" },
  { key: "localite", label: "Localité" },
];

// Cascading editor: each level is a combobox (choose an existing value OR type a new one).
// Choosing a parent filters the suggestions of its children.
export const LocationEditor = ({ value = {}, onChange }) => {
  const [opts, setOpts] = useState({});

  const load = useCallback((level, filters) => {
    const qs = new URLSearchParams({ level });
    Object.entries(filters).forEach(([k, v]) => v && qs.set(k, v));
    api.get(`/localisations?${qs.toString()}`).then((r) => setOpts((o) => ({ ...o, [level]: r.data }))).catch(() => {});
  }, []);

  // Preload options for every level whose parents are already filled (edit mode).
  useEffect(() => {
    load("region", {});
    LEVELS.forEach((l, i) => {
      if (i > 0 && value[LEVELS[i - 1].key]) {
        const filters = {};
        for (let j = 0; j < i; j++) filters[LEVELS[j].key] = value[LEVELS[j].key];
        load(l.key, filters);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const change = (level, v) => {
    const idx = LEVELS.findIndex((l) => l.key === level);
    const next = { ...value, [level]: v };
    for (let i = idx + 1; i < LEVELS.length; i++) next[LEVELS[i].key] = "";
    onChange(next);
    if (idx + 1 < LEVELS.length) {
      const filters = {};
      for (let i = 0; i <= idx; i++) filters[LEVELS[i].key] = next[LEVELS[i].key];
      load(LEVELS[idx + 1].key, filters);
    }
  };

  return (
    <div className="grid grid-cols-1 gap-3 py-1">
      {LEVELS.map((l) => {
        const listId = `loc-datalist-${l.key}`;
        return (
          <div key={l.key}>
            <label className="text-xs text-stone-500">{l.label}</label>
            <Input
              list={listId}
              value={value[l.key] || ""}
              onChange={(e) => change(l.key, e.target.value)}
              placeholder={`Choisir ou ajouter — ${l.label}`}
              className="h-9"
              data-testid={`loc-field-${l.key}`}
              autoComplete="off"
            />
            <datalist id={listId}>
              {(opts[l.key] || []).map((o) => <option key={o} value={o} />)}
            </datalist>
          </div>
        );
      })}
    </div>
  );
};
